import {
	CreditQuoteAction,
	CreditQuoteResponse,
	creditQuoteResponseSchema,
} from "@signalist/shared-types";

import { api } from "@/redux/api";

import { BulkContactInfoRequest } from "../../pages/List/utils/bulkContactInfoRequest";

/** A quote request: the action and the selection exactly as the action itself takes it. */
export type CreditQuoteRequest = BulkContactInfoRequest & { action: CreditQuoteAction };

/**
 * `POST list/creditQuote` (PREC-4263): what a bulk lookup or a lead scoring retrigger would cover
 * and cost, resolved by the API with the action's own rules, select-all included. A query, not a
 * mutation: nothing runs and nothing is charged. It is fetched each time a dialog opens, since the
 * leads' statuses change between two opens.
 */
export const creditQuoteApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getCreditQuote: builder.query<CreditQuoteResponse, CreditQuoteRequest>({
			query: (body) => ({
				url: "list/creditQuote",
				method: "POST",
				body,
				responseSchema: creditQuoteResponseSchema,
			}),
			keepUnusedDataFor: 0,
		}),
	}),
});

export const { useGetCreditQuoteQuery } = creditQuoteApi;
